export const selectFrequency = ['Daily', 'Weekly', 'Monthly'];

export const frequencyTypes = {
  Weekly: 1,
  Monthly: 2,
  Daily: 3,
  1: 'Weekly',
  2: 'Monthly',
  3: 'Daily',
};

export const enumSlots = {
  FullDay: {
    type: 1,
    startTime: '00:00',
    endTime: '23:59',
    amount: '',
  },
  'Full day': {
    type: 1,
    startTime: '00:00',
    endTime: '23:59',
    amount: '',
  },
  Breakfast: {
    type: 2,
    startTime: '08:00',
    endTime: '11:59',
    amount: '',
  },
  Lunch: {
    type: 3,
    startTime: '12:00',
    endTime: '17:59',
    amount: '',
  },
  Dinner: {
    type: 4,
    startTime: '18:00',
    endTime: '23:59',
    amount: '',
  },
};
export const slotType = {
  1: 'Full day',
  2: 'Breakfast',
  3: 'Lunch',
  4: 'Dinner',
  'Full day': 1,
  Breakfast: 2,
  Lunch: 3,
  Dinner: 4,
};

export const expiryUnits = ['Day', 'Week', 'Month'];

export const days = [
  {
    value: 1,
    label: 'Monday',
  },
  {
    value: 2,
    label: 'Tuesday',
  },
  {
    value: 3,
    label: 'Wednesday',
  },
  {
    value: 4,
    label: 'Thursday',
  },
  {
    value: 5,
    label: 'Friday',
  },
  {
    value: 6,
    label: 'Saturday',
  },
  {
    value: 7,
    label: 'Sunday',
  },
];

export const dates = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
];

export const infoLabels = {
  groups:
    'Select from the group of employees. If you have not created any group, please create one first.',
  name: 'Max 30 characters allowed',
  group_name: 'Please specify group name in not more than 50 characters',
  daily: 'Credit will happen only on day(s) selected',
  weekly: 'Credit will happen only on day selected',
  neverEnd: 'Plan will remain active unless deactivated',
  accumulating:
    'Subsequent top-ups will be equal to amount used by each employee in previous cycle',
  startDate:
    'First top-up will be done on this date & the cycle repeats basis the top-up frequency',
  endDate: 'No top-ups will happen after this date',
  limitStartDate: 'Meal plan will start on this date',
  limitEndDate: ' ',
  restrictionType: 'Restrict daily usage by the employee',
};

export const emptyStateMessage = 'No wallet programs have been created yet.';

export const programCreationSuccess = {
  title: 'Meal plan created successfully',
  subtitle: 'Access your plans in the ‘Meal Plans’ section',
};

export const shareUTRSuccess = {
  title: 'UTR/Reference No. submitted',
  subtitle: 'We will verify the payment and approve/reject it within 24 hours',
};

export const programStartDateError =
  'Program start date and time cannot be in past';

export const programEndDateError =
  'Plan end date and time cannot be before a month from start date';

export const programTimeDelayError =
  'Program start time should be at least one hour ahead of current time.';

export const slotStartTimeError = 'Should be greater than';
export const slotEndTimeError = 'Should be less than';
export const slotStartTimeGreaterThanEndTime =
  'Start time greater than end time';

export const programConfirmTitle =
  'Do you confirm, if you want to create this wallet program?';

/* ********** Gift card program form *********** */

export const giftCardCountHelperTxt =
  'Gift cards codes will be sent to the SPOC email ID in the form of a .xls file on the start date and time.';

export const selectGroupsHelperTxt =
  'Employees will get the gift card on their email ID as well as their zomato account tagged to their corporate email ID';

export const giftCardAmountHelperText = `Amount per gift card cannot be more than ${String.fromCharCode(
  0x20b9,
)}10,000`;

export const giftCardExpiryInfo =
  'Gift cards will be created after payment is complete and will expire 1 year after creation';

export const MAX_AMOUNT_PER_GIFT_CARD = 10000;
export const MAX_GIFT_CARD_COUNT = 1000000;

export const DRAFTED = 'DRAFTED';
